import React from 'react';
import {CardElement, injectStripe} from 'react-stripe-elements';

class Checkout extends React.Component
{
    constructor(props)
    {
        super(props);
        this.submit = this.submit.bind(this)
        this.state = {
            loaded: true,
            paymentComplete: false,
            errorMessage: ""
        };
    }
    componentDidMount()
    {
        if (this.props.cart.grandTotal === 0.00)
        {
            this.setState({loaded: false})
            this.props.api.send({
                controller: "Cart",
                action: "charge",
                method: "post",
                body: JSON.stringify({cardtoken: ""}),
                success: (response) => {
                    this.setState({loaded: true, paymentComplete: true});
                },
                error: (err) => {
                    this.setState({errorMessage: "An error occurred while assigning your courses.  Please try again later.", loaded: true})
                }
            })
        }
    }
    async submit(e)
    {
        this.setState({loaded: false});
        let {token} = await this.props.stripe.createToken({name: "Name"});
        if (token != null)
        {
            const rememberToken = localStorage.getItem("LMSToken");
            const sessionToken = sessionStorage.getItem("LMSToken");
            var authtoken  = rememberToken ? rememberToken : sessionToken ? sessionToken : null;
            var headers = {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
            if (authtoken != null)
            {
                headers['Authorization'] = "Bearer " + authtoken;
            }
            const url = "/api/Cart/Charge";
            let response = await fetch(url, {
                method: "post",
                body: JSON.stringify({cardtoken: token.id}),
                headers: headers,
            });
            if (response.ok)
            {
                console.dir(this.state);
                this.setState({loaded: true, paymentComplete: true});
            }
            else
            {
                this.setState({errorMessage: "An error occurred while processing your card.  Please try again later.", loaded: true})
            }
        } 
        else 
        {
            this.setState({errorMessage: "An error occurred while getting your card details.  Please try again later.", loaded: true})
        }
    }
    render()
    {
        return (
            <div>
                { this.props.cart.loaded && this.state.loaded ? 
                    this.state.paymentComplete ? (
                        <div>
                            Purchase complete.  Continue to <a href="/Dashboard" className="bodylink">Dashboard</a>.
                        </div>
                    ) : (
                    <div>
                        <strong>${this.props.cart.grandTotal.toFixed(2)}</strong>
                        
                    </div>
                ) : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
                { !this.state.paymentComplete ? (
                    <CardElement className="lmscardelement" />
                ) : null}
                { this.props.cart.loaded && this.state.loaded && ! this.state.paymentComplete ? (
                    <div>
                        <button className="lmsbutton" onClick={this.submit}>Submit Payment</button>
                        <div className="lmsvalidationerror">{this.state.errorMessage}</div>
                    </div>
                ) : null}
            </div>
        )
    }
}

export default injectStripe(Checkout);


// WEBPACK FOOTER //
// ./src/course/catalog/checkout.js